// extracted by mini-css-extract-plugin
export default {"font-renta":"Approve_font-renta__ixWMr","signatureNameClarification":"Approve_signatureNameClarification__v6V1d"};